import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  compareFeatures: {
    defaultMessage: 'Compare Features',
    description: 'Header label for the collapsible compare features section',
    id: '3ggQHY',
  },
});
